import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login";
import ListaExames from "../views/ListaExames";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/listaexames",
    name: "ListaExames",
    component: ListaExames,
    props: true,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach(async (to, from, next) => {
  if (to.name !== "Login" && !store.state.protocolo && from.name !== "Login") {
    return next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
